import { useMemo } from 'react';

import { useCanAccessCommunicationsDashboard } from '../../featureChecks';
import { UseMainUIFeatureSettings, uiFeatureAccessSymbol } from '../../types';

export const useCommsDashboardLeadersAndAudiencesPageSettings: UseMainUIFeatureSettings<
  'communicationsDashboardLeadersAndAudiencesPage'
> = (options) => {
  const canAccessDashboard = useCanAccessCommunicationsDashboard();

  return useMemo(() => {
    const overrides = options?.overrides?.communicationsDashboardLeadersAndAudiencesPage ?? {};

    return {
      [uiFeatureAccessSymbol]: canAccessDashboard,
      ...overrides,
    };
  }, [options, canAccessDashboard]);
};
